import React from 'react';
import {
  ChiTietDon,
  QuaTrinhXuLy
} from 'modules/giai-quyet-don/subView';
import { Reception, LetterProcessingWorkFlow } from 'api';
import { Link, browserHistory } from 'react-router';
import ThongTinYeuCauKiemTraDeXuat from './ThongTinYeuCauKiemTraDeXuat.jsx';
import ThongTinGiaiQuyet from './ThongTinGiaiQuyet.jsx';
import KetQuaThongTinGiaiQuyet from './KetQuaThongTinGiaiQuyet.jsx';
import { ShowIf } from 'components/utils';

class CanBoNhanKetQuaKiemTraDeXuat extends React.Component {
  constructor(props, context){
    super(props, context)
    this.state = {
      isOpen: true,
      id: this.props.params.id,
      donId: '',
      data: [],
      dataLichSuGiaiQuyet: [],
      dataThongTinYeuCauKiemTraDeXuat: [],
      dataTaiLieuVanThu: [],
      yKienXuLy: '',
      dataLichSuQuaTrinhXuLy: [],
      coQuanToChucTiepDan: [],
      listTLBC: []
    }
  }

  componentDidMount() {
    this.getDetailReception();
    this.getSoTiepCongDanInfo(this.props.params.id);
  }

  getQuyTrinhXuLyHistory(id) {
    LetterProcessingWorkFlow.actions.getQuyTrinhXuLyHistory.request({ donId: id }).then(res => {
      if(res.data._embedded) {
        this.setState({ dataLichSuQuaTrinhXuLy: res.data ? res.data._embedded.lichSuQuaTrinhXuLies : [] });
      }
    });
  }

  getSoTiepCongDanInfo(inputId) {
    Reception.actions.getSoTiepCongDanInfo.request({ id: inputId }).then(res => {
      if (res.data) {
        this.setState({
          dataTaiLieuVanThu: res.data.listTaiLieuVanThu
        });
      }
    });
  }

  getDetailReception() {
    Reception.actions.getDetailReception.request({id: this.state.id}).then(res => {
      if (res && res.data) {
        let getDonId = '';
        if (res.data.donSTCD && res.data.donSTCD.donId) {
          getDonId = res.data.donSTCD.donId;
        }
        Reception.actions.getDonInfo.request({ id: getDonId}).then(resTLBC => {
          if (resTLBC && resTLBC.data && resTLBC.data.listTaiLieuBangChung && resTLBC.data.listTaiLieuBangChung.length > 0) {
            this.setState({listTLBC: resTLBC.data.listTaiLieuBangChung});
          }
        });
        this.setState({
          dataThongTinYeuCauKiemTraDeXuat: res.data.thongTinYeuCauKiemTraDeXuatInfo,
          yKienXuLy: res.data.yKienXuLy,
          donId: getDonId,
          data: res.data.donSTCD,
          coQuanToChucTiepDan: res.data.coQuanToChucTiepDanSTCD
        });
        this.getQuyTrinhXuLyHistory(getDonId);
      } else {
        this.setState({
          dataThongTinYeuCauKiemTraDeXuat: [],
          yKienXuLy: '',
          donId: '',
          data: [],
          coQuanToChucTiepDan: []
        })
      }
    });
  }

  render() {
    return (
      <section className='center'>
        <div className="back-foward">
          <Link onClick={browserHistory.goBack} title="" >Về trang trước</Link>
        </div>
        <div className="heading">
          <h2 className="heading-title icon-detail">Giải quyết đơn/vụ việc cần kiểm tra</h2>
        </div>
        <div className="page-wrapper mb30">
          <ChiTietDon isOpen={this.state.isOpen} donId={this.state.id} dataGiaiQuyet={this.state.dataLichSuGiaiQuyet} listTLBC={this.state.listTLBC} data={this.state.data} coQuanToChucTiepDan = {this.state.coQuanToChucTiepDan}/>
          <QuaTrinhXuLy parents={this}/>
          <ThongTinYeuCauKiemTraDeXuat data={this.state.dataThongTinYeuCauKiemTraDeXuat} donInfo={this.state.data}/>
          <ShowIf condition={!this.props.viewOnly}>
            <ThongTinGiaiQuyet id={this.state.id} donId={this.state.donId}/>
          </ShowIf>
          {<ShowIf condition={this.props.viewOnly}>
            <KetQuaThongTinGiaiQuyet id={this.state.id} donId={this.state.donId}/>
          </ShowIf>}
        </div>
      </section>
    );
  }
}

export default CanBoNhanKetQuaKiemTraDeXuat;


// WEBPACK FOOTER //
// ./src/components/modules/reception/CanBoNhanKetQuaKiemTraDeXuat.jsx